// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.checkboxes-list[data-v-7f8445bb] {\n  display: block;\n  width: 100%;\n  padding: 20px 35px 35px;\n}\n", ""]);
// Exports
module.exports = exports;
